/* Kessoro v51 — Arthur Hendon product page behavior (ah-product).
   Variant selection, price updates, gallery carousel + counter, size-guide modal.
   Add-to-cart itself is handled by Dawn's <product-form> (product-form.js),
   which opens the theme cart drawer. */
(function () {
  if (customElements.get('ah-product')) return;

  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });

  function fmt(cents) {
    return money.format(cents / 100);
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  class AhProduct extends HTMLElement {
    connectedCallback() {
      var jsonEl = this.querySelector('[data-ah-product-json]');
      try {
        this.product = JSON.parse(jsonEl.textContent);
      } catch (e) {
        this.product = null;
      }

      this.track = this.querySelector('[data-ah-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-ah-slide]'));
      this.counter = this.querySelector('[data-ah-counter]');
      this.priceEl = this.querySelector('[data-ah-price]');
      this.compareEl = this.querySelector('[data-ah-compare]');
      this.idInput = this.querySelector('input[name="id"]');
      this.atc = this.querySelector('[data-ah-atc]');
      this.atcLabel = this.querySelector('[data-ah-atc-label]');
      this.stockEl = this.querySelector('[data-ah-stock]');

      var self = this;

      // --- gallery counter + nav ---
      if (this.track) {
        var raf = null;
        this.track.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            self.updateCounter();
          });
        });
        this.addEventListener('click', function (e) {
          var nav = e.target.closest('[data-ah-nav]');
          if (!nav) return;
          var dir = nav.getAttribute('data-ah-nav') === 'next' ? 1 : -1;
          var w = self.track.clientWidth;
          var max = self.track.scrollWidth - w;
          var target = self.track.scrollLeft + dir * w;
          if (target > max + 2) target = 0;
          if (target < -2) target = max;
          self.track.scrollTo({ left: target, behavior: 'smooth' });
        });
      }

      // --- variant radios ---
      this.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('[data-ah-value]')) {
          self.onOptionChange();
        }
      });

      // --- size guide modal ---
      this.modal = this.querySelector('[data-ah-modal]');
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-ah-modal-open]') && self.modal) {
          self.modal.hidden = false;
          document.body.style.overflow = 'hidden';
        }
        if (e.target.closest('[data-ah-modal-close]') && self.modal) {
          self.closeModal();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.modal && !self.modal.hidden) self.closeModal();
      });
    }

    closeModal() {
      this.modal.hidden = true;
      document.body.style.overflow = '';
    }

    updateCounter() {
      if (!this.counter || !this.slides.length) return;
      var w = this.slides[0].offsetWidth || 1;
      var i = Math.round(this.track.scrollLeft / w);
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      this.counter.textContent = pad(i + 1);
    }

    selectedOptions() {
      var out = [];
      var fieldsets = this.querySelectorAll('[data-ah-option-index]');
      for (var i = 0; i < fieldsets.length; i++) {
        var checked = fieldsets[i].querySelector('[data-ah-value]:checked');
        out.push(checked ? checked.value : null);
      }
      return out;
    }

    findVariant(opts) {
      if (!this.product) return null;
      return this.product.variants.find(function (v) {
        return opts.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      }) || null;
    }

    onOptionChange() {
      var opts = this.selectedOptions();
      var variant = this.findVariant(opts);

      // Update the small selected-value labels next to COLOR / SIZE
      var fieldsets = this.querySelectorAll('[data-ah-option-index]');
      for (var i = 0; i < fieldsets.length; i++) {
        var label = this.querySelector('[data-ah-option-value="' + i + '"]');
        if (label && opts[i]) label.textContent = opts[i];
      }

      if (!variant) {
        if (this.atc) {
          this.atc.setAttribute('disabled', '');
          if (this.atcLabel) this.atcLabel.textContent = 'Unavailable';
        }
        return;
      }

      // Hidden id input (Dawn's product-form reads this on submit)
      if (this.idInput) {
        this.idInput.value = variant.id;
        this.idInput.disabled = false;
      }

      // Price + compare
      if (this.priceEl) this.priceEl.textContent = fmt(variant.price);
      if (this.compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this.compareEl.textContent = fmt(variant.compare_at_price);
          this.compareEl.hidden = false;
        } else {
          this.compareEl.hidden = true;
        }
      }

      // ATC state
      if (this.atc) {
        if (variant.available) {
          this.atc.removeAttribute('disabled');
          if (this.atcLabel) this.atcLabel.textContent = 'Add to bag';
        } else {
          this.atc.setAttribute('disabled', '');
          if (this.atcLabel) this.atcLabel.textContent = 'Sold out';
        }
      }

      // Urgency only makes sense for a purchasable variant
      if (this.stockEl) this.stockEl.style.display = variant.available ? '' : 'none';

      // Jump gallery to the variant's image
      if (variant.featured_image && variant.featured_image.position && this.track) {
        var idx = variant.featured_image.position - 1;
        var slide = this.slides[idx];
        if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      // Keep URL shareable
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }
  }

  customElements.define('ah-product', AhProduct);
})();
